/* eslint-disable */ 
import React, { useState ,useEffect} from "react";
import { logo } from "../_components/Imagepath";

const ForgotPasswordNotifications = (props) => {

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src={logo}
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Password Reset Request</h1>
                  <br></br>
                  <p className="text-center">
                    We've sent a password reset link to your email. Please check your inbox and follow the instructions to reset your password.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ForgotPasswordNotifications;
